import React from 'react'
import styled from '@emotion/styled'
import { Container, Typography } from '@mui/material'
import { jobInfo } from '../../data/data'

const SomosContainer = styled(Container)`
  text-align: center;
  margin: 100px 0 100px 0;
  padding-top: 200px;
`

const Somos = () => (
  <SomosContainer id='Somos-Container'>
    <Typography variant="h1" sx={{ marginBottom: 2 }}>
      Somos
    </Typography>
    <Typography variant="h3">
    Tu tintorería de confianza. En Super Hollywood nos enorgullece ofrecer servicios de alta calidad, especializados en arreglos y lavados de todo tipo de prendas. Desde nuestras instalaciones en el corazón de Chacao, hemos brindado por más de 60 años servicios 
    excepcionales a empresas y personas, ayudándolos a lucir impecables.

    <p>Contamos con un equipo especializado en la excelencia en cada detalle, garantizando un servicio rápido, confiable y con los mejores precios de todo el mercado. Descubre la comodidad de contar con Super Hollywood, donde la calidad encuentra la asequibilidad.</p>
  
    
    </Typography>
  </SomosContainer>
)

export default Somos
